import { ReactNode } from 'react';
import * as Style from './divider-styles.module.less';
import classNames from 'classnames';

type Alignment = 'left' | 'right' | 'center';

export const Divider = (props: {
    children?: ReactNode;
    position?: Alignment;
    className?: string;
}) => {
    let position = '';
    switch (props.position) {
        case 'left':
            position = Style.leftAligned;
            break;
        case 'right':
            position = Style.rightAligned;
            break;
        case 'center':
        default:
            position = Style.centered;
    }
    if (!props.children) {
        position = Style.noContent;
    }
    const className = classNames(Style.divider, position, 'm-y-3', props.className);
    return <div className={className}>{props.children}</div>;
};
